import Flickity from 'flickity';

const initJournalSlider = (elements) => {
    elements.forEach((element) => {
        const flickityOptions = {
            autoPlay: false,
            cellAlign: 'left',
            contain: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            watchCSS: true,
        };

        const carousel = new Flickity(element, flickityOptions); // eslint-disable-line
    });
};

export { initJournalSlider as default};